/**
 * @file  nonce.ts
 * @description  set nonce rules to allow inline styles that are blocked by the content-security-policy unsafe-inline
 *
 * @author ogarcia (ozkary)
 */

/* global __webpack_nonce__ */ // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars

// allow webpack to inject a nonce token to the files that are imported
// this problem is created by the styled-component inline styles, constant.js file during the rendering of chunks
__webpack_nonce__ = btoa(new Date().getTime().toString()); // eslint-disable-line no-global-assign, camelcase
